import { DateTime } from 'luxon';

export function generateIntervalTimeList(interval: number): string[] {
  const times: string[] = [];
  const startOfDay = DateTime.local().startOf('day');

  for (let minutes = 0; minutes < 24 * 60; minutes += interval) {
    const time = startOfDay.plus({ minutes });
    times.push(time.toLocaleString(DateTime.TIME_24_SIMPLE));
  }

  return times;
}
